module.exports = __webpack_public_path__ + "img/how-three.359af306.svg";